import {useEffect, useMemo} from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { AppBar, Toolbar, useMediaQuery } from '@mui/material';

// project import
import HeaderContent from './HeaderContent';
import IconButton from '../../../Components/@extended/IconButton';

import { MenuOrientation, ThemeMode } from '../../../config';
import useConfig from '../../../hooks/useConfig';
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
// import {getSubscriptions} from "../../../store/reducer/xero_connection";

const Header = (props) => {
    const LogoutButton = props.LogoutButton;
    const handlerSetSubscriptionSelect = props.handlerSetSubscriptionSelect;

    const headerContent = useMemo(() => <HeaderContent LogoutButton={LogoutButton} handlerSetSubscriptionSelect={handlerSetSubscriptionSelect} getUsersList={props.getUsersList} getSubscriptions={props.getSubscriptions} handlerResetPayables={props.handlerResetPayables}/>, []);


    // app-bar params
    const appBar = {
        position: 'fixed',
        color: 'inherit',
        elevation: 0,
        sx: {
            borderBottom: `1px solid`,
            zIndex: 1200,
            width: '100%',
            // boxShadow: theme.customShadows.z1
            }
    };

    const mainHeader = (
        <>
            <Navbar bg="dark" variant="dark">
            <Container>
              <Navbar.Brand href="/">Ikigai</Navbar.Brand>
              <Nav className="me-auto">
                <Nav.Link href="/">Home</Nav.Link>
                  <Nav.Link href="/analytics/dashboard">Analytics Dashboard</Nav.Link>
                  {/*<Nav.Link href="/permissions">Permissions</Nav.Link>*/}
                  {/*<Nav.Link href="/getreport">Get Report</Nav.Link>*/}
                  {/*<Nav.Link href="/taxchatbot">Tax Chatbot</Nav.Link>*/}
                  {/*<Nav.Link href="/apps/kanban">Kanban</Nav.Link>*/}
                  <Nav.Link href='/getting-started'>Get Started</Nav.Link>
                  {/*<Nav.Link href='/faq'>FAQ</Nav.Link>*/}
                  <Nav.Link href='/contact-us'>Contact Us</Nav.Link>
              </Nav>
            </Container>
            <Toolbar>
                {headerContent}
            </Toolbar>
            </Navbar>
        </>
    )

    return (
        <>
            <AppBar {...appBar}>{mainHeader}</AppBar>
        </>
    )
}

export default Header;